import { tagGroups } from '@hungryroot/tags';
import { ControlTagTernary } from '../ControlTagTernary/ControlTagTernary';

interface Props {
  testid?: string;
  customerId: number;
  isTwoColumnRow?: boolean;
}

export function KidsSnacksContent(props: Props) {
  const { testid, customerId, isTwoColumnRow } = props;
  return (
    <div data-testid={testid}>
      <ControlTagTernary
        customerId={customerId}
        tagGroupId={tagGroups.kidsSnacks}
        isTwoColumnRow={isTwoColumnRow}
      />
    </div>
  );
}
